jQuery(document).ready(function(){
   new Swiper('.swiper-container', {
      loop: false,
      lazy: true,
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function(index, className) {
          return `<span class="outer-dot swiper-pagination-bullet" data-index="${
            index + 1
          }"><span class="inner-dot"></span></span>`;
        }
      },
      on: {
            slideChange: function () {
                let updatedIndex = this.realIndex + 1; // 1-based index
                //alert('Current slide index:', this.realIndex);
                
                // Update current slide display
                $('.swiper-slider-current-slide .current-slide').html('Current Slide: ' + updatedIndex);
                
                // Update pagination bullets
                $('.swiper-pagination-bullet').removeClass('swiper-pagination-bullet-active');
                
                // Update only the bullet corresponding to the current slide
                $('.swiper-pagination-bullet[data-index="' + updatedIndex + '"]').addClass('swiper-pagination-bullet-active');
            }
        }
    });   

// 
  var color2 = $('.pdp-custom-swatch-list-item').attr('data-color').toLowerCase();
  //alert("belt-strap"+color2);
  jQuery('.thumbnails-options .thumb-img[data-alt="'+color2+'"]').show();
  jQuery('.thumbnails-options .thumb-img[data-alt!="'+color2+'"]').hide();
  $('.products-images-sections .thumbnails-options .thumb-img:first-child').addClass('thumb-img-active');

  var color3 = $('.multipdp-custom-swatch-list-item').attr('data-color').toLowerCase();
  //alert("belt-buckle"+color3);
  jQuery('.thumbnails-options .thumb-img[data-alt="'+color3+'"]').show();
  jQuery('.thumbnails-options .thumb-img[data-alt!="'+color3+'"]').hide();
  $('.products-images-sections .thumbnails-options .thumb-img:first-child').addClass('thumb-img-active');


/************************************updated code*********************************/

jQuery('body').on('click', '.multipdp-custom-swatch-list-item', function() {
    const color1 = jQuery(this).attr('data-color');

    const color2 = jQuery('.pdp-custom-swatch-list-item.active, .pdp-custom-swatch-list-item.selected').attr('data-color') || jQuery('.pdp-custom-swatch-list-item').first().attr('data-color');

    const color10 = (color1 + " - " + color2).toLowerCase();

    const thumbImages = document.querySelectorAll('.thumb-img');
    let matchedIndex = -1;

    for (let index = 0; index < thumbImages.length; index++) {
        const thumbImg = thumbImages[index];
        if (thumbImg.getAttribute('data-alt').toLowerCase() === color10) {
            matchedIndex = index;
            break;
        }
    }

    if (matchedIndex !== -1) {
        // Hide all thumbs
        jQuery('.thumbnails-options .thumb-img').hide();
        jQuery('.thumbnails-options .thumb-img').filter(function() {
            return jQuery(this).attr('data-alt').toLowerCase() === color10;
        }).show().removeClass('thumb-img-active').first().addClass('thumb-img-active');

        jQuery('.current-main-images .thumb-img').hide().removeClass('showThis');
        jQuery('.current-main-images .thumb-img').filter(function () {
            return jQuery(this).attr('data-alt').toLowerCase() === color10;
        }).show().first().addClass('showThis');

    } else {
        //alert('No matching image found for: ' + color10);
    }
});

jQuery('body').on('click', '.pdp-custom-swatch-list-item', function() {
    const color11 = jQuery(this).attr('data-color');

    const color12 = jQuery('.multipdp-custom-swatch-list-item.selected-click').attr('data-color') || jQuery('.multipdp-custom-swatch-list-item').first().attr('data-color');

    const color13 = (color12 + " - " + color11).toLowerCase();

    const thumbImages = document.querySelectorAll('.thumb-img');
    let matchedIndex = -1;

    for (let index = 0; index < thumbImages.length; index++) {
        const thumbImg = thumbImages[index];
        if (thumbImg.getAttribute('data-alt').toLowerCase() === color13) {
            matchedIndex = index;
            break;
        }
    }

    if (matchedIndex !== -1) {
        jQuery('.thumbnails-options .thumb-img').hide();

        jQuery('.thumbnails-options .thumb-img').filter(function() {
            return jQuery(this).attr('data-alt').toLowerCase() === color13;
        }).show().removeClass('thumb-img-active').first().addClass('thumb-img-active');

        jQuery('.current-main-images .thumb-img').hide().removeClass('showThis');
        jQuery('.current-main-images .thumb-img').filter(function () {
            return jQuery(this).attr('data-alt').toLowerCase() === color13;
        }).show().first().addClass('showThis');

        //alert(color13);
    } else {
        //alert('No matching image found for: ' + color13);
    }
});

/*******************************************************************************/
  
    jQuery('.pdp-custom-swatch-list-item').removeClass('active');
    jQuery(this).parent('.pdp-custom-swatch-list-item').addClass('active');
	jQuery('.pdp-custom-styles span.style-click').click(function(){
		var getstyle = $(this).text();
		jQuery('.sek-style-seec').text(getstyle);
	});

	var getstyle2 = jQuery('.pdp-custom-styles span.style-click.Selective-style').text();
	jQuery('.sek-style-seec').text(getstyle2);
	jQuery('.thumbnails-options .thumb-img.match-color:first-child').addClass('thumb-img-active');
	jQuery('body').on('click', '.thumbnails-options .thumb-img', function() {
			jQuery('.thumbnails-options .thumb-img').removeClass('thumb-img-active');
			jQuery(this).addClass('thumb-img-active');
	});

    
    jQuery('body').on('click', '.thumbnails-options .thumb-img', function() {
      let getCurrentIndex = Number($(this).attr('data-ind'));
      $(document).find('.swiper-pagination .swiper-pagination-bullet[data-index="' + (
        getCurrentIndex + 1
      ) + '"]').click();
      //alert(getCurrentIndex);
    })

    const swatchItems = document.querySelectorAll('.pdp-custom-swatch-list-item');
    const styles = document.querySelectorAll('.pdp-custom-styles');
    
    swatchItems.forEach(item => {
        item.addEventListener('mouseover', () => {
            styles.forEach(style => {
                style.style.zIndex = 0; // Hover par z-index change karna
            });
        });
    
        item.addEventListener('mouseout', () => {
            styles.forEach(style => {
                style.style.zIndex = 1; // Mouse out par z-index reset karna
            });
        });
    });

});